export enum DsLiveToastStyleEnum {
  Success = "success",
  Notice = "notice",
  Critical = "critical",
  Warning = "warning",
}
